module.exports = __webpack_public_path__ + "static/media/Abdomen, pelvis & buttocks.9ba79675.png";